import { Colors } from "@flatfile/design-system";
import { Border } from "../../../common/UI/Borders.js";
import { NumberCellStyles, UnderlinedCellStyles } from "../Styles.js";
import styled from "styled-components";
const Container = styled.div`
  box-shadow: ${(props) => !props.theme.cell.active.boxShadow || props.noShadow ? "none" : props.theme.cell.active.boxShadow};
  position: relative;
  width: 100%;
  height: 100%;

  ${(props) => {
  const adjustTop = props.isFirstNonHeaderRow;
  const adjustBottom = props.isLastRow;
  const adjustLeft = props.isFirstColumn;
  if (adjustLeft || adjustTop || adjustBottom) {
    return `
        input {
          ${adjustTop ? "margin-top: -1px;" : ""}
          ${adjustBottom ? "margin-top: 1px;" : ""}
          ${adjustLeft ? "margin-left: -1px;" : ""}
        }

        span {
          ${adjustTop ? "margin-top: 0px;" : ""}
          ${adjustBottom ? "margin-top: 2px;" : ""}
          ${adjustLeft ? "margin-left: -1px;" : ""}
        }
      `;
  }
}}
`;
const SharedEditorStyles = (baseFontSize, rowHeight, isFirstNonHeaderRow, isFirstColumn) => {
  const lineHeight = 18;
  const editorHeight = isFirstNonHeaderRow ? rowHeight + 0.25 : rowHeight + 1.5;
  const borderWidth = 1;
  const verticalPadding = Math.max(
    0,
    (editorHeight - 2 * borderWidth - lineHeight) / 2
  );
  const leftPadding = isFirstColumn ? 7 : 8;
  return `
  font-size: ${baseFontSize};
  font-family: inherit;
  outline: none;
  min-height: ${editorHeight}px;
  line-height: ${lineHeight}px;
  overflow: hidden;
  padding: ${verticalPadding}px 0 ${verticalPadding}px ${leftPadding}px;
`;
};
const StyledEditorInput = styled.textarea`
  ${(props) => SharedEditorStyles(
  props.theme.baseFontSize,
  props.theme.rowHeight,
  props.isFirstNonHeaderRow,
  props.isFirstColumn
)};
  color: ${(props) => props.theme.cell.color};
  z-index: 1;
  width: 100%;
  min-width: 100%;
  resize: none;
  margin: 0;
  background: ${Colors.White};
  overflow: hidden;
  ${(props) => props.number && NumberCellStyles}
  ${(props) => props.isUnderline && UnderlinedCellStyles}

  border-radius: ${(props) => props.theme.tooltip.borderRadius};
  border: ${(props) => Border.status(props)};
  box-shadow: ${(props) => props.theme.cell.active.boxShadow};

  &:focus {
    outline: none;
  }
`;
const StyledEditorValueClone = styled.div`
  ${(props) => SharedEditorStyles(
  props.theme.baseFontSize,
  props.theme.rowHeight,
  props.isFirstNonHeaderRow,
  props.isFirstColumn
)};
  position: absolute;
  white-space: nowrap;
  z-index: -1;
  border: 1px solid transparent;
  padding-right: 8px;
  visibility: hidden;
`;
export {
  Container,
  StyledEditorInput,
  StyledEditorValueClone
};
